// @flow
import React from 'react'
import type { LeadformCustomQuestion } from '../types'
import Select from '../controls/Select'
import Options from './Options'
import _ from 'lodash'
import LimitedInput from '../AdEdit/AdInputs/LimitedInput'
import LabeledWrapper from '../AudienceEdit/LabeledWrapper'

const customQuestionTitleMaxLength = 200

const t = {
  title: 'Заголовок',
  question: 'Вопрос',
  question_type: 'Тип вопроса',
  add: 'добавить',
  input: 'Строка',
  textarea: 'Многострочный текст',
  radio: 'Выбор ответа из готовых вариантов',
  checkbox: 'Выбор нескольких ответов из готовых вариантов',
  select: 'Выбор готового ответа из выпадающего списка'
}

type Props = {|
  data: LeadformCustomQuestion,
  onChange: (LeadformCustomQuestion) => void
|}

function renderEditor(data: LeadformCustomQuestion, onChange) {
  if (data.options && hasOptions(data.type)) {
    return (
      <div>
        <Options
          data={data.options}
          onChange={(options) => {
            const question = _.cloneDeep(data)
            question.options = options
            onChange(question)
          }}
        />
      </div>
    )
  }
}

function hasOptions(type: string) {
  return _.includes(['radio', 'checkbox', 'select'], type)
}

export default function CustomQuestion({ data, onChange }: Props) {
  return (
    <div>
      <LabeledWrapper label={t.question_type} bottomPadding={8}>
        <div className="t-LeadformCustomQuestion__type">
          <Select
            value={data.type}
            options={[
              { id: 'input', name: t.input },
              { id: 'textarea', name: t.textarea },
              { id: 'radio', name: t.radio },
              { id: 'checkbox', name: t.checkbox },
              { id: 'select', name: t.select }
            ]}
            onChange={(value) => {
              if (hasOptions(value)) {
                if (hasOptions(data.type)) {
                  onChange({ type: value, title: data.title, options: data.options })
                } else {
                  onChange({ type: value, title: data.title, options: ['', ''] })
                }
              } else {
                onChange({ type: value, title: data.title })
              }
            }}
          />
        </div>
      </LabeledWrapper>
      <LabeledWrapper label={t.title} bottomPadding={8}>
        <LimitedInput
          className="t-CustomQuestionInput"
          value={data.title}
          maxLength={customQuestionTitleMaxLength}
          onChange={(value) => onChange({ ...data, title: value })}
        />
      </LabeledWrapper>
      {renderEditor(data, onChange)}
    </div>
  )
}
